import _ from 'lodash';
import React, { Component, Suspense, lazy  } from 'react';
import { connect } from 'react-redux';
import LocaleStrings from 'Languages';


class Dashboard extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
   
    }

    render() {
        var { session } = this.props;

        return (
            <div>
               Dashboard
            </div>
        );
    }
}

function mapStateToProps(state) {

    return {
        session: state.session,
       
    };
}

export default connect(mapStateToProps, {})(Dashboard);